import React from 'react';
import { AuthCardStep, AuthAddressStep, AuthAddress2Step } from '../steps';
import { useAddCardModal } from './useAddCardModal';

type AddCardModalViewProps = ReturnType<typeof useAddCardModal>;

export const AddCardModalView: React.FC<AddCardModalViewProps> = ({
    step,
    isLoading,
    savedCard,
    savedAddress,
    stepError,
    dismissError,
    onCardSubmit,
    onAddressSubmit,
    onAddress2Submit,
}) => {
    switch (step) {
        case 'card2':
            return (
                <AuthCardStep
                    loading={isLoading}
                    onCardSubmit={onCardSubmit}
                    showNameOnCard
                    defaultCard={savedCard}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'address':
            return (
                <AuthAddressStep
                    loading={isLoading}
                    onAddressSubmit={onAddressSubmit}
                    defaultAddress={savedAddress}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'address2':
            return (
                <AuthAddress2Step
                    key={savedAddress?.countryCode ?? 'US'}
                    loading={isLoading}
                    address={savedAddress}
                    onAddress2Submit={onAddress2Submit}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        default:
            return null;
    }
};
